// extracted by mini-css-extract-plugin
module.exports = {"SArticle":"TrailerPoster_SArticle__5U1O3","SPlaySvg":"TrailerPoster_SPlaySvg__pJXEs"};